let contador = 0;

export const getNegativeId = () => {
	contador = contador - 1;
	return contador;
};
